<template>
  <div
    class="page"
   :style="currentPageBg"
  >
  
    <Logo></Logo>
    <backBtn @getParentChapterList="getParentChapterList"></backBtn>
    <mbtns></mbtns>
    <pcbtns></pcbtns>
    <pcmiddlebg :imgurl="middlebgurl+'?v='+$version" class="pcmiddlebg"></pcmiddlebg>
    <mmiddlebg :imgurl="middlebgurl+'?v='+$version" :middle-items="chapterList" class="mmiddlebg" />
    <pc-bottom-area :middle-items="chapterList" @getSubChapter="getChapterData" />
    <m-bottom-area :middle-items="chapterList" @getSubChapter="getChapterData" />
  </div>
</template>

<script>
import Logo from "../components/Logo";
import pcbtns from "../components/pcbtns";
import pcmiddlebg from "../components/pcmiddlebg";
import mmiddlebg from "../components/mmiddlebg";
import pcBottomArea from "../components/pcBottomArea";
import mBottomArea from "../components/mBottomArea";
import backBtn from "../components/BackBtn";
import mbtns from "../components/mbtns";
export default {
  name: "chapter",
  components: {
    Logo,
    pcbtns,
    pcmiddlebg,
    mmiddlebg,
    pcBottomArea,
    mbtns,
    mBottomArea,
    backBtn
  },
  created() {
    this.setGlobleTitle(this.$route.query.name + " - " + this.globleTitle);
    //根据对应的chapterName显示对应的章节样式
    this.matchChapterStyle(this.$route.query.name);
    this.getChapterData(this.$route.query.id);
  },
  updated() {
    // pc端
    if(document.body.clientWidth>768){
       //获取上一章章节数组，保持上一次的顺序
      let oldActiveChapterArray = JSON.parse(
        window.sessionStorage.getItem("activeChaperArraySort")
      );
      if (oldActiveChapterArray && oldActiveChapterArray.length) {
        this.chapterList = oldActiveChapterArray;
        //把上一章章节数组数据置为null
        window.sessionStorage.setItem(
          "activeChaperArraySort",
          JSON.stringify(null)
        );
      }
    }
   
  },
  data() {
    return {
      middlebgurl: "",
      chapterList: [],
      parentChapterLists: [],
      chapterListIds: [],
      currentPageBg:{
        background: "#d8d9bd",
        color: "#f2676b"
      },
      bottomAreaNormalStyle: {
        background: "#d8d9bd",
        color: "#f2676b"
      },
      bottomAreaActiveStyle: {
        color: "#f2676b",
        background: "#ffebd7"
      },
      is_bggk: false,
      is_rgxz: false,
      is_zygk: false,
      is_zyly: false,
      is_dzfw: false,
      is_bfdt: false
    };
  },
  methods: {
    //匹配样式
    matchChapterStyle(chapterName) {
     var currentIndexItem = JSON.parse(sessionStorage.getItem('currentIndexItem'));
    // console.log('currentIndexItem',currentIndexItem);
     this.currentPageBg = {
       background:currentIndexItem.chapterPageBg,
     }
     this.bottomAreaNormalStyle.background = currentIndexItem.normalStyle.background;
     this.bottomAreaActiveStyle.background = currentIndexItem.activeStyle.background;
    this.bottomAreaNormalStyle.color = currentIndexItem.normalStyle.color;
    this.bottomAreaActiveStyle.color = currentIndexItem.activeStyle.color;
       
    },
    // 章节列表的id排序，便于内容页中切换内容
    sortChapterListIds(chapterList) {
      for (let i = 0; i < chapterList.length; i++) {
        let allchildchapters = chapterList[i].allchildchapters;
        if (allchildchapters && allchildchapters.length) {
          //递归调用
          this.sortChapterListIds(allchildchapters);
        } else {
          var obj = {
            name: chapterList[i].name,
            id: chapterList[i].id
          };
          this.chapterListIds.push(obj);
        }
      }
    },

    getParentChapterList() {
      this.setGlobleTitle(this.$route.query.name + " - " + this.globleTitle);
      this.matchChapterStyle(this.$route.query.name);
      this.chapterList = this.pathInfo.parentChapter[0];
      
     
    },
    //获取章节内容
    getChapterData(chapterId) {
      // pid  类型guid  章的id
      this.$http
      .post(this.base_url().baseurl+"/xszl/api/Chapter/pChapter",{
        pid:chapterId
      }).then(res=>{
       
        let data = JSON.parse(res.body.Chapters);
        this.middlebgurl =this.base_url().img_baseurl+data.ChapterThemeImg.mvisitimg;
      });
      this.$http
        .post(this.base_url().baseurl + "/xszl/api/Chapter/Chapters", {
          pid: chapterId
        })
        .then(
          res => {
            let data = JSON.parse(res.body.Chapters);
            

            if (data && data.length) {
              for (let i = 0; i < data.length; i++) {
                data[i].isActive = false;
                data[i].isHover = false;
                  //云南大学的
                var currentIndexItem = JSON.parse(sessionStorage.getItem('currentIndexItem'));
                data[i].normalStyle = currentIndexItem.normalStyle;
                data[i].activeStyle = currentIndexItem.activeStyle;
              }

              this.chapterList = data;
              console.log('chapterList',this.chapterList);
              //存储最原始的的sort由小到大排列的数据
              window.sessionStorage.setItem(
                "initchapterData",
                JSON.stringify(data)
              );
              
              this.sortChapterListIds(this.chapterList);
              //存储
              window.sessionStorage.setItem(
                "chapterListIds",
                JSON.stringify(this.chapterListIds)
              );
            }
          },
          res => {
            console.log("请求失败处理", res); //失败处理
          }
        );
    }
  }
  // }
};
</script>

<style scoped>
@import "../css/chapter.css";
</style>